import styled, { css } from 'styled-components'
import { COLORS } from '@styles/colors'
import { DEVICES } from '@constants/global'
import { FONTS } from '@styles/fonts'

const NavItemStyle = css`
  font-family: ${FONTS.medium};
  color: ${COLORS.secondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  min-width: 80px;

  svg {
    color: ${COLORS.primary};
    margin-bottom: 8px;
  }
`

export const PropertyMobileNavItem = styled.div`
  ${NavItemStyle};
  padding: 10px;

  &:last-of-type {
    margin-right: 0;
  }

  &:first-of-type {
    margin-left: 0;
  }

  ${({ active }) =>
    active &&
    css`
      cursor: default;
      background-color: #FAF8F3;

      svg {
        color: ${COLORS.secondary} !important;
      }
    `}
`

export const PropertyMobileNavItemLink = styled.a`
  ${NavItemStyle};
`

export const PropertyMobileNav = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 999;
  width: 100%;
  background-color: ${COLORS.nature[95]};
  padding: 10px 16px;
  display: none;

  @media ${DEVICES.mobile} {
    display: flex;
    align-items: flex-end;
  }

  ${({ justifyBetween }) =>
    justifyBetween &&
    css`
      justify-content: space-between;
    `}
`
